import { MonitorColorType } from "components/report/ChatArea/chatColors";

export const colors = {
  backgroundlinear: {
    main: {
      start: "#F9F3C4",
      end: "#FBBBBC",
    },
    secondary: {
      start: "#c4e0fb",
      end: "#b5f2de",
    },
  },

  priamry: "#E77C1A",
  secondary: "#F88280",
  danger: "#d46e6e",
  error: "red",
  interview: "#9CC813",
  disable: "#aaaaaa",
  form: {
    background: "#eeeeee",
    focused: "#eaf1fd",
  },
  text: "#524D47",

  white: "#ffffff",
  black: "#000000",

  moderatorTextBalloonBackGround: "#FEF4D1",

  lightGray: "#cccccc",
  dimgray: "#555555",
  silver: "#c0c0c0",
};

export const monitorColors: { [key in MonitorColorType]: string } = {
  green: "#6AB74F",
  purple: "#B74EA0",
  sakura: "#F1686A",
  tomato: "#FF6347",
  crimson: "#DC143C",
  lime: "#32CD32",
  turquoise: "#40E0D0",
  sky: "#87CEEB",
  mikan: "#F8CB62",
};
